import React from 'react';

const DownloadPDF = () => {
  return (
    <button
      onClick={() => window.print()}
      className="no-print mono text-xs uppercase tracking-widest text-zinc-500 hover:text-zinc-900 transition-colors"
    >
      Descargar PDF ↓
    </button>
  );
};

export default DownloadPDF;
